import editNovedadTurnoForm from './editNovedadesTurnoFormModel';
const {
  formField: {
    // DATOS PARAMETROS
    e_colaborador,
    e_responsable,
    e_tipoNovedad,
    e_fechaNovedad,
    e_horaNovedad,
    e_description,
  },
} = editNovedadTurnoForm;

export default {
  [e_colaborador.name]: '',
  [e_responsable.name]: '',
  [e_tipoNovedad.name]: '',
  [e_fechaNovedad.name]: null,
  [e_horaNovedad.name]: '',
  [e_description.name]: '',
};
